package com.schoolconnect.app.feature.notices

import com.schoolconnect.app.feature.attendance.ParentAttendanceChild
import com.schoolconnect.app.feature.common.PaginationPolicy

data class ParentNoticesUiState(
    val children: List<ParentAttendanceChild> = emptyList(),
    val selectedChildIndex: Int = 0,
    val rows: List<NoticeRowUi> = emptyList(),
    val isLoading: Boolean = true,
    val errorMessage: String = "",
    val matchingCount: Int = 0,
    val totalCount: Int = 0,
    val activeCount: Int = 0,
    val expiredCount: Int = 0,
    val todayCount: Int = 0,
    val searchQuery: String = "",
    val period: String = "All",
    val periodFrom: String = "",
    val periodTo: String = "",
    val status: String = "All",
    val pageIndex: Int = 0,
    val pageSize: Int = PaginationPolicy.DEFAULT_PAGE_SIZE,
    val sortField: NoticesSortField = NoticesSortField.PUBLISHED_DATE,
    val sortAscending: Boolean = false,
    val viewingNotice: NoticeRowUi? = null,
    val viewingDetail: NoticeDetailUi? = null,
    val isViewingLoading: Boolean = false,
    val viewingError: String = ""
) { val selectedChild get() = children.getOrNull(selectedChildIndex) }

sealed interface ParentNoticesUiEvent {
    data class ChildSelected(val index: Int) : ParentNoticesUiEvent
    data class SearchChanged(val value: String) : ParentNoticesUiEvent
    data class PeriodChanged(val value: String) : ParentNoticesUiEvent
    data class CustomPeriodApplied(val from: String, val to: String) : ParentNoticesUiEvent
    data class StatusChanged(val value: String) : ParentNoticesUiEvent
    data object FiltersCleared : ParentNoticesUiEvent
    data class PageChanged(val index: Int) : ParentNoticesUiEvent
    data class PageSizeChanged(val size: Int) : ParentNoticesUiEvent
    data class SortChanged(val field: NoticesSortField) : ParentNoticesUiEvent
    data class ViewRequested(val row: NoticeRowUi) : ParentNoticesUiEvent
    data object ViewDismissed : ParentNoticesUiEvent
}
